import { styled } from '@linaria/react';
import { bodyFont, fonts, semantic, space } from '../../theme/tokens';

export const CardWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const SelectedInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['space-100']};
`;

export const QuantityText = styled.span`
  font-family: ${bodyFont};
  font-size: ${fonts.size.base};
  color: ${semantic.text.primary};
`;
